import { Ti18nKeys } from "../../../../../constants/i18n";
import { ColorsEnum } from "../../../../../core/et3-theme/colors";
import { TUserKeys } from "../../../../../Types";

export type TExpiryDefinition = {
  labelKey: Ti18nKeys;
  userKey: TUserKeys;
  tierColor: string;
};

export const EXPIRY_TAG_HEIGHT = 30;
export const EXPIRY_TAG_PADDING = 10;
export const EXPIRY_TAG_RADIUS_CSS = "8px";
export const EXPIRY_TAG_GAP = 7;
export const EXPIRY_TIER_FONT_SIZE = 12;
export const EXPIRY_DATE_FONT_SIZE = 11;

export const FREEMIUM_EXPIRY_FIELDS: TExpiryDefinition[] = [
  {
    labelKey: "SILVER_TAG",
    userKey: "freemiumSilverUntil",
    tierColor: ColorsEnum.plumBrown
  },
  {
    labelKey: "GOLD_TAG",
    userKey: "freemiumGoldUntil",
    tierColor: ColorsEnum.bronzedGold
  },
  {
    labelKey: "PLATINUM_TAG",
    userKey: "freemiumPlatinumUntil",
    tierColor: ColorsEnum.mutedSteelBlue
  },
  {
    labelKey: "BLACK_TAG",
    userKey: "freemiumBlackUntil",
    tierColor: ColorsEnum.black
  },
  {
    labelKey: "VIP",
    userKey: "freemiumVIPUntil",
    tierColor: ColorsEnum.vipGold
  },
  {
    labelKey: "PLUS",
    userKey: "freemiumPLUSUntil",
    tierColor: ColorsEnum.purple
  }
];

export const PAYING_EXPIRY_FIELDS: TExpiryDefinition[] = [
  {
    labelKey: "SILVER_TAG",
    userKey: "payingSilverUntil",
    tierColor: ColorsEnum.plumBrown
  },
  {
    labelKey: "GOLD_TAG",
    userKey: "payingGoldUntil",
    tierColor: ColorsEnum.bronzedGold
  },
  {
    labelKey: "PLATINUM_TAG",
    userKey: "payingPlatinumUntil",
    tierColor: ColorsEnum.mutedSteelBlue
  },
  {
    labelKey: "BLACK_TAG",
    userKey: "payingBlackUntil",
    tierColor: ColorsEnum.black
  },
  {
    labelKey: "VIP",
    userKey: "payingVIPUntil",
    tierColor: ColorsEnum.vipGold
  },
  {
    labelKey: "PLUS",
    userKey: "payingPLUSUntil",
    tierColor: ColorsEnum.purple
  },
  {
    labelKey: "BUNDLE",
    userKey: "payingPowerUntil",
    tierColor: ColorsEnum.powerPurple
  },
  {
    labelKey: "KHATTABAT_TAG",
    userKey: "payingKhattabatUntil",
    tierColor: ColorsEnum.brightCyan
  }
];
